import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "SMTP - Servidor de Envio")
      ])
    ])
  ])
], -1)
const _hoisted_13 = { class: "ui-card-body" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_22 = { class: "ui-card ui-mt-30" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Notificações")
      ])
    ])
  ])
], -1)
const _hoisted_24 = { class: "ui-card-body" }
const _hoisted_25 = { class: "ant-row ui-flex-center" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Editar")
], -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Cancelar")
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Confirmar")
], -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "ant-row" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_37 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, "Variáveis:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_campo_email = _resolveComponent("campo-email")!
  const _component_campo_senha = _resolveComponent("campo-senha")!
  const _component_card = _resolveComponent("card")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_a_form_item, { label: "Identificação/Nome no E-mail" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.configuracao.smtp.identificacao) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.configuracao.smtp.identificacao]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, { label: "Servidor" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.configuracao.smtp.servidor) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.configuracao.smtp.servidor]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, { label: "Porta" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.configuracao.smtp.porta) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.configuracao.smtp.porta]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_form_item, { label: "Utiliza SSL?" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.configuracao.smtp.ssl,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.configuracao.smtp.ssl) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Não")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Sim")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_form_item, { label: "E-mail" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_email, {
                          valor: _ctx.state.configuracao.smtp.email,
                          "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.configuracao.smtp.email) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, { label: "Senha" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_senha, {
                          valor: _ctx.state.configuracao.smtp.senha,
                          "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.configuracao.smtp.senha) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.configuracao.notificacoesEmails, (notificacao) => {
                  return (_openBlock(), _createBlock(_component_card, {
                    titulo: _ctx.obterDescricaoTipoNotificacao(notificacao.tipo),
                    key: notificacao.codigo
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, " Destinatário(s): " + _toDisplayString(_ctx.obterDestintariosTipoNotificacaoEmail(notificacao.tipo, notificacao.destinatarios)), 1),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("button", {
                            class: "ui-button -second ui-full",
                            type: "button",
                            onClick: ($event: any) => (_ctx.apresentarModalEdicaoNotificacao(notificacao))
                          }, _hoisted_30, 8, _hoisted_28)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["titulo"]))
                }), 128))
              ])
            ]),
            (_ctx.state.apresentarModalNotificacao)
              ? (_openBlock(), _createBlock(_component_a_modal, {
                  key: 0,
                  keyboard: false,
                  title: 'Notificação: ' + _ctx.obterDescricaoTipoNotificacao(_ctx.state.notificacaoEmailEmEdicao.tipo),
                  centered: "",
                  width: 1200,
                  visible: _ctx.state.apresentarModalNotificacao,
                  "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.apresentarModalNotificacao) = $event))
                }, {
                  footer: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "ui-button -second",
                        type: "button",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.apresentarModalNotificacao = false))
                      }, _hoisted_32),
                      _createElementVNode("button", {
                        class: "ui-button -primary",
                        type: "button",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.confirmarAlteracoesNotificaoEmail()))
                      }, _hoisted_34)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_form, { layout: "vertical" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_a_form_item, { label: "Assunto" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.notificacaoEmailEmEdicao.assunto) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.notificacaoEmailEmEdicao.assunto]
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        (_ctx.preencherDestintariosTipoNotificacaoEmail(_ctx.state.notificacaoEmailEmEdicao.tipo))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createVNode(_component_a_form_item, { label: "Destinatários" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_email, {
                                      valor: _ctx.state.notificacaoEmailEmEdicao.destinatarios,
                                      "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.notificacaoEmailEmEdicao.destinatarios) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_divider, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Conteúdo do E-mail")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tooltip, { title: "Clique na váriavel para copiar e cole no local desejado no E-mail" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _hoisted_39,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.variaveisTipoNotificacao, (variavel) => {
                                return (_openBlock(), _createBlock(_component_a_tag, {
                                  style: {"cursor":"pointer"},
                                  key: variavel.variavel,
                                  onClick: ($event: any) => (_ctx.copiarVariavel(variavel.variavel))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("b", null, _toDisplayString(variavel.variavel), 1),
                                    _createTextVNode(" - " + _toDisplayString(variavel.descricao), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_editor_html, {
                          value: _ctx.state.notificacaoEmailEmEdicao.conteudo,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.notificacaoEmailEmEdicao.conteudo) = $event)),
                          minHeight: '900'
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["title", "visible"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}